module.exports = __webpack_public_path__ + "static/img/Bronze_badge.a5ad506.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Bronze_badge.png
// module id = 985
// module chunks = 1